import { FC } from 'react'
import { PageContent } from 'components/common/Page/PageContent'

/** Placeholder for workspace tabs that are not yet implemented (Plan, Brand Assets, Billing) */
export const WorkspacePlaceholderContent: FC = () => {
  return <PageContent>placeholder</PageContent>
}
